import { atom } from "recoil";
import { AtomKeys } from "stores/storeKeys";

/**
 * 処理完了メッセージ、エラーメッセージ
 */
export type NoticeMessageStateType = {
  message: string | null;
  status: "success" | "warning" | "failure" | null;
};

export const NoticeMessageState = atom<NoticeMessageStateType>({
  key: AtomKeys.NOTICE_MESSAGE_STATE,
  default: { message: null, status: null },
});
